const addTimeZero = value => {
  if (value < 10) {
    return `0${ value }`
  }

  return value.toString();
}

const formatTime = seconds => {
  if (seconds < 60) {
    return `00:${ addTimeZero(seconds) }`
  }

  const minutes = Math.floor(seconds / 60);
  const leftoverSeconds = seconds % 60;

  return `${ addTimeZero(minutes) }:${ addTimeZero(leftoverSeconds) }`
}

export {
  formatTime
}
